import {
  ChangeDetectorRef, Component, Input, OnDestroy, OnInit, inject
} from '@angular/core';
import { AsyncPipe, DatePipe, DecimalPipe, UpperCasePipe } from '@angular/common';
import { MatDialog, MatDialogRef, MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { interval, startWith, Subject, Subscription, switchMap, takeUntil } from 'rxjs';

import { AuthService } from '../../services/auth/auth.service';
import { BookingService } from '../../services/api/BookingService';
import { SharedTherapistDetailService } from '../../services/shared-therapist-detail.service';

import { TherapistModel } from '../../models/api/TherapistModel';
import { TherapistStatusHistoryModel } from '../../models/api/TherapistStatusHistoryModel';
import { TherapistDashboardService } from '../../services/api/TherapistDashboardService';
import { TherapistDashboardModel } from '../../models/api/TherapistDashboardModel';
import { BookingModelExtra } from '../../models/api/BookingModelExtra';
import { TimeDiffPipe } from '../../pipes/time-diff.pipe';
import { TherapistBreakDialogService } from '../../services/therapist-break.service';
import { Grid_BookingModel } from '../../models/api/Grid_BookingModel';
import { ActivatedRoute, Router } from '@angular/router';
import { TherapistEventService } from '../../services/api/TherapistEventService';
import { TherapistEventModel } from '../../models/api/TherapistEventModel';
import { TherapistEventDetailsModel } from '../../models/api/TherapistEventDetails';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthLoginResult } from '../../models/auth/AuthLoginResult';


@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [UpperCasePipe, MatButtonModule, MatDialogModule, DatePipe, MatProgressBarModule, TimeDiffPipe, DecimalPipe],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class TherapistDashboardComponent implements OnInit, OnDestroy {
  @Input() parentData: any;

  private stopBookingPollingNew$ = new Subject<void>();

  newCurrentBooking: BookingModelExtra = new BookingModelExtra;
  
  newMassageLength: number = 0;

  waitTimeLength: number = 0;
  private massageTimerIntervalNew: any;
  newCustomerDataChanged: boolean = false;

  //Boolenas for error state / loading etc / preventing double click
  gettingNextBooking: boolean = false;
  changeBookingStatusClicked: boolean = false;

  public therapistEventData: TherapistEventDetailsModel = new TherapistEventDetailsModel;

  systemUserId: number = 0;
  //therapistId: number | undefined;
  therapistDetail: TherapistModel = new TherapistModel;
  therapistStatusDetail: TherapistStatusHistoryModel = new TherapistStatusHistoryModel;
  timeSinceStatusChange: number | undefined;
  activeTherapistStatusHistoryDetail: TherapistStatusHistoryModel = new TherapistStatusHistoryModel;
  private subscriptions: Subscription = new Subscription();


  //activeBooking: BookingModelExtra = new BookingModelExtra;
  nextBooking: Grid_BookingModel = new Grid_BookingModel;
  currentBooking: BookingModelExtra = new BookingModelExtra;

  therapistDashboard: TherapistDashboardModel = new TherapistDashboardModel;

  readonly dialog = inject(MatDialog);

  private declineBookingDialogRef: MatDialogRef<DeclineBookingDialog> | null = null;


  constructor(private authService: AuthService,
    private therapistDashboardService: TherapistDashboardService,
    private bookingService: BookingService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private therapistEventService: TherapistEventService,
    private therapistBreakDialogService: TherapistBreakDialogService,
    private sharedTherapistDetailService: SharedTherapistDetailService,
    private snackbar: MatSnackBar) { }


  ngOnInit(): void {
    debugger;
    this.getDashboardData();
    this.getCurrentBooking();


    this.sharedTherapistDetailService.therapistData$.subscribe({
      next: (data) => {
        this.therapistDetail = data;
      },
      error: (err) => {
        debugger;
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authorised to get the therapsit data', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Unable to get therapist ata, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 500) {
          this.snackbar.open('Server error, please try agan later', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
      }
    })

  }

  getCurrentBooking() {
    //GETS A CURRENT OR ACTIVE BOOKING IF THERE IS ONE.
    //CURRENT BOOKING IS A BOOKING THAT IS ASSIGNED TO THE THERAPIST.
    //ACTIVE BOOKING IS ONLY WHEN THE BOOKING IS IN PROGRESS!!
    this.bookingService.getCurrentBooking().subscribe({
      next: (data) => {

        if (data.bookingID > 0) {
          this.newCurrentBooking = data;

          this.newCurrentBooking.bookingDate = toUtcDate(this.newCurrentBooking.bookingDate);

          if (this.newCurrentBooking.treatmentEnd) {
            this.newCurrentBooking.treatmentStart = toUtcDate(this.newCurrentBooking.treatmentStart);
            this.newCurrentBooking.treatmentEnd = toUtcDate(this.newCurrentBooking.treatmentEnd);
            this.newMassageLength = (((this.newCurrentBooking.treatmentStart.getTime() - this.newCurrentBooking.treatmentEnd.getTime()) / 1000) / 60);
          }
          else if (this.newCurrentBooking.treatmentStart) {
            this.newCurrentBooking.treatmentStart = toUtcDate(this.newCurrentBooking.treatmentStart);
            this.setMassageTimerNew(this.newCurrentBooking.treatmentStart, this.newCurrentBooking.treatmentEnd, this.newCurrentBooking.bookingID, 'instance 1');
          }

          if (this.newCurrentBooking.bookingStatusID === 3 || this.newCurrentBooking.bookingStatusID === 4) {
            this.checkBookingDetails();
            this.setMassageWaitTimerNew(this.newCurrentBooking.bookingDate);
          }
        }
      },
      error: (err) => {
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authorised to get this booking.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Booking not found, please try again', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please check the booking and try again', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 500) {
          this.snackbar.open('Server error, please try agan later', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
      }
    })
  }

  doRefreshToken(): void {
    let l: AuthLoginResult | undefined = this.authService.getAuthUserRecordFromLocalStorage();

    if (l != undefined && l != null) {


      this.authService.refreshToken(l!).subscribe({
        next: (res) => {
        },
        error: (err) => {
          if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authorised to refresh your token', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Unable to refresh token please try again.', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 500) {
          this.snackbar.open('Server error, please try agan later', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        }
      });
    }
  }

  getDashboardData() {

    //this.doRefreshToken();

    const dashboardPollSub = interval(5000).pipe(
      startWith(0),
      switchMap(() => this.therapistDashboardService.getTherapistDashboard())
    ).subscribe({
      next: (data) => {
        this.therapistDashboard = data;

        if (data.currentStatusID === 1 || data.currentStatusID === 5) {
          this.sharedTherapistDetailService.triggerClockInPopup();
        }
      },
      error: (err) => {
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authorised to view this dashboard.', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Therapist details not found, please try again.', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please try again.', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 500) {
          this.snackbar.open('Server error, please try agan later', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
      }
    })
    this.subscriptions.add(dashboardPollSub);
  }

  ngOnDestroy(): void {
    if (this.massageTimerIntervalNew) {
      clearInterval(this.massageTimerIntervalNew);
    }
    this.subscriptions.unsubscribe();
  }


  viewMyQueue() {
    this.router.navigate(['therapist-portal', 'queue', 'my-queue']);
  }

  viewAnyQueue() {
    this.router.navigate(['therapist-portal', 'queue', 'any-queue']);
  }

  getNextBooking() {

    this.gettingNextBooking = true;

    this.newCustomerDataChanged = false;
    this.newCurrentBooking = new BookingModelExtra;
    this.newMassageLength = 0;
    this.waitTimeLength = 0;
    if (this.massageTimerIntervalNew) {
      clearInterval(this.massageTimerIntervalNew);
    }

    this.bookingService.getNextBooking().subscribe({
      next: (data) => {

        if (data.bookingID > 0) {
          this.newCurrentBooking = data as unknown as BookingModelExtra;
          this.newCurrentBooking.bookingDate = toUtcDate(this.newCurrentBooking.bookingDate);
          if (this.newCurrentBooking.bookingStatusID === 3 || this.newCurrentBooking.bookingStatusID === 4) {
            this.checkBookingDetails();
            this.setMassageWaitTimerNew(this.newCurrentBooking.bookingDate);
          }
        }
        this.gettingNextBooking = false;
      },
      error: (err) => {
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authorised to get this booking.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Booking details not found, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 500) {
          this.snackbar.open('Server error, please try agan later', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        this.gettingNextBooking = false;
      }
    })
  }

  private checkBookingDetails() {
    interval(5000)
      .pipe(
        switchMap(() => this.bookingService.getCurrentBooking()),
        takeUntil(this.stopBookingPollingNew$)
      )
      .subscribe({
        next: (data) => {

          if (!data.bookingID) {
            this.newCurrentBooking.bookingStatusID = 7;
            this.stopBookingPollingNew$.next();
            this.cdr.markForCheck();
          }
          if (data.location !== this.newCurrentBooking.location) {
            this.newCurrentBooking.location = data.location;
            this.newCustomerDataChanged = true;
            this.cdr.markForCheck();
          }
          if (data.otherNotes !== this.newCurrentBooking.otherNotes) {
            this.newCurrentBooking.otherNotes = data.otherNotes;
            this.newCustomerDataChanged = true;
            this.cdr.markForCheck();
          }
        },
        error: (err) => {
          if (err.errorCode === 0) {
            this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
          }
          else if (err.errorCode === 401) {
            this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
            this.logOutUser();
          }
          else if (err.errorCode === 403) {
            this.snackbar.open('You are not authorised to view this booking.', 'Dismiss');
            this.router.navigate(['therapist-portal', 'dashboard']);
          }
          else if (err.errorCode === 404) {
            this.snackbar.open('Booking details not found, please try again.', 'Dismiss');
            this.router.navigate(['therapist-portal', 'dashboard']);
          }
          else if (err.errorCode === 400) {
            this.snackbar.open('Invalid request, please try again.', 'Dismiss');
            this.router.navigate(['therapist-portal', 'dashboard']);
          }
          else if (err.errorCode === 500) {
            this.snackbar.open('Server error, please try agan later', 'Dismiss');
            this.router.navigate(['therapist-portal', 'dashboard']);
          }
        }
      });
  }


  private setMassageWaitTimerNew(bookingDate: Date) {
    this.updateMassageWait(bookingDate);

    this.massageTimerIntervalNew = setInterval(() => {
      this.updateMassageWait(bookingDate);
    }, 10000);
  }

  private updateMassageWait(bookingDate: Date) {
    const bookDate: Date = new Date(bookingDate);
    const now = new Date();
    const diffMs = now.getTime() - bookDate.getTime();
    const timeInSecs = diffMs / 1000;
    const timeInMins = timeInSecs / 60;
    this.waitTimeLength = timeInMins;
  }


  private setMassageTimerNew(treatmentStartDate: Date, treatmentEndDate: Date, bookingID: number, instance: string) {
    this.updateMassageLength(treatmentStartDate, bookingID, instance);
    this.massageTimerIntervalNew = setInterval(() => {
      this.updateMassageLength(treatmentStartDate, bookingID, instance);
    }, 10000);
  }

  private updateMassageLength(treatmentStartDate: Date, bookingID: number, instance: string) {
    const treatmentStart: Date = new Date(treatmentStartDate);

    const now = new Date();
    const diffMs = now.getTime() - treatmentStart.getTime();
    const timeInSecs = diffMs / 1000;
    const timeInMins = timeInSecs / 60;
    this.newMassageLength = timeInMins;

  }

  acceptBookingNew(bookingID: number) {

    this.changeBookingStatusClicked = true;

    this.therapistDashboardService.acceptBooking(bookingID).subscribe({
      next: (data) => {
        this.newCurrentBooking.bookingStatusID = 4;
        this.cdr.markForCheck();
        this.changeBookingStatusClicked = false;
      },
      error: (err) => {
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authorised to accept this booking.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Booking status could not be changed, please try again', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 500) {
          this.snackbar.open('Server error, please try agan later', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        this.changeBookingStatusClicked = false;
      }
    })
  }

  startMassageNew(bookingID: number) {

    this.changeBookingStatusClicked = true;

    this.therapistDashboardService.startBooking(bookingID).subscribe({
      next: (data) => {
        this.waitTimeLength = 0;
        this.stopBookingPollingNew$.next();
        this.newCurrentBooking.bookingStatusID = 5;
        this.newCurrentBooking.treatmentStart = new Date();
        this.setMassageTimerNew(this.newCurrentBooking.treatmentStart, this.newCurrentBooking.treatmentEnd, this.newCurrentBooking.bookingID, 'instance 2');

        this.changeBookingStatusClicked = false;

        this.cdr.markForCheck();
      },
      error: (err) => {
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authorised to start this massage', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Massage not found, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 500) {
          this.snackbar.open('Server error, please try agan later', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        this.changeBookingStatusClicked = false;
      }
    })
  }

  endMassageNew(bookingID: number) {

    this.changeBookingStatusClicked = true;

    this.therapistDashboardService.endBooking(bookingID).subscribe({
      next: (data) => {

        this.waitTimeLength = 0;
        this.newCurrentBooking.bookingStatusID = 6;
        if (this.massageTimerIntervalNew) {
          clearInterval(this.massageTimerIntervalNew);
        }

        this.bookingService.getBookingById(bookingID).subscribe(data => {
          this.newCurrentBooking = data as unknown as BookingModelExtra;
        })

        this.changeBookingStatusClicked = false;
        this.cdr.markForCheck();
      },
      error: (err) => {
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authorised to end this massage', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Unable to end massage, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 500) {
          this.snackbar.open('Server error, please try agan later', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        this.changeBookingStatusClicked = true;
      }
    })
  }

  endMassageWithBreakNew(bookingID: number) {

    this.changeBookingStatusClicked = true;

    this.therapistDashboardService.endBooking(bookingID).subscribe({
      next: (data) => {
        this.waitTimeLength = 0;
        this.newCurrentBooking.bookingStatusID = 6;
        if (this.massageTimerIntervalNew) {
          clearInterval(this.massageTimerIntervalNew);
        }

        this.newMassageLength = 0;

        this.bookingService.getBookingById(bookingID).subscribe({
          next: (data) => {
            this.newCurrentBooking = data as unknown as BookingModelExtra;
          },
          error: (err) => {
            if (err.errorCode === 0) {
              this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
            }
            else if (err.errorCode === 401) {
              this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
              this.logOutUser();
            }
            else if (err.errorCode === 403) {
              this.snackbar.open('You are not authorised to get this booking.', 'Dismiss');
              this.router.navigate(['therapist-portal', 'dashboard']);
            }
            else if (err.errorCode === 404) {
              this.snackbar.open('Unable to get booking, please try again.', 'Dismiss');
              this.router.navigate(['therapist-portal', 'dashboard']);
            }
            else if (err.errorCode === 400) {
              this.snackbar.open('Invalid request, please try again.', 'Dismiss');
              this.router.navigate(['therapist-portal', 'dashboard']);
            }
            else if (err.errorCode === 500) {
              this.snackbar.open('Server error, please try agan later', 'Dismiss');
              this.router.navigate(['therapist-portal', 'dashboard']);
            }
          }
        })
        this.changeBookingStatusClicked = true;


        this.cdr.markForCheck();
      },
      error: (err) => {
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authorised to end this massage.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Unable to end massage, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 500) {
          this.snackbar.open('Server error, please try agan later', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        this.changeBookingStatusClicked = true;
      }
    })

    this.therapistDashboardService.startBreak().subscribe({
      next: (data) => {
        this.therapistDetail.therapistStatusID = 4;
      },
      error: (err) => {
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authorised to start a break', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Unable to start break, please try again', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 500) {
          this.snackbar.open('Server error, please try agan later', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
      }
    })
  }

  massageCancelledNew(bookingID: number) {

    this.changeBookingStatusClicked = true;

    this.therapistDashboardService.bookingDidNotHappen(bookingID).subscribe({
      next: (data) => {
        this.waitTimeLength = 0;
        this.newCurrentBooking = new BookingModelExtra;
        if (this.massageTimerIntervalNew) {
          clearInterval(this.massageTimerIntervalNew);
        }
        this.newMassageLength = 0;
        this.changeBookingStatusClicked = false;
        this.cdr.markForCheck();
      },
      error: (err) => {
        if (err.errorCode === 0) {
          this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
        }
        else if (err.errorCode === 401) {
          this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
          this.logOutUser();
        }
        else if (err.errorCode === 403) {
          this.snackbar.open('You are not authorised to cancel this massage.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 404) {
          this.snackbar.open('Massage details not found, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 400) {
          this.snackbar.open('Invalid request, please try again.', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        else if (err.errorCode === 500) {
          this.snackbar.open('Server error, please try agan later', 'Dismiss');
          this.router.navigate(['therapist-portal', 'dashboard']);
        }
        this.changeBookingStatusClicked = false;
      }
    })
  }

  declineBookingNew(bookingID: number) {

    this.changeBookingStatusClicked = true;

    this.declineBookingDialogRef = this.dialog.open(DeclineBookingDialog, {
      panelClass: 'therapist-portal-dialog',
      disableClose: true,
      backdropClass: 'dialog-blur',
    })


    this.declineBookingDialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.therapistDashboardService.declineBooking(bookingID).subscribe({
          next: (data) => {
            this.waitTimeLength = 0;
            this.newCurrentBooking = new BookingModelExtra;
            if (this.massageTimerIntervalNew) {
              clearInterval(this.massageTimerIntervalNew);
            }
            this.newMassageLength = 0;
            this.changeBookingStatusClicked = false;
            this.cdr.markForCheck();
          },
          error: (err) => {
            if (err.errorCode === 0) {
              this.snackbar.open('Network error. Please check your internet connection and try again', 'Dismiss');
            }
            else if (err.errorCode === 401) {
              this.snackbar.open('Your session has expired. Please log in and try again', 'Dismiss');
              this.logOutUser();
            }
            else if (err.errorCode === 403) {
              this.snackbar.open('You are not authorised to decline this massage.', 'Dismiss');
              this.router.navigate(['therapist-portal', 'dashboard']);
            }
            else if (err.errorCode === 404) {
              this.snackbar.open('Massage details not found, please try again.', 'Dismiss');
              this.router.navigate(['therapist-portal', 'dashboard']);
            }
            else if (err.errorCode === 400) {
              this.snackbar.open('Invalid request, please try again.', 'Dismiss');
              this.router.navigate(['therapist-portal', 'dashboard']);
            }
            else if (err.errorCode === 500) {
              this.snackbar.open('Server error, please try agan later', 'Dismiss');
              this.router.navigate(['therapist-portal', 'dashboard']);
            }
            this.changeBookingStatusClicked = false;
          }
        })
      } else {
        this.changeBookingStatusClicked = false;
      }
    })
  }

  quickCreateNewBooking() {
    this.router.navigate(['therapist-portal', 'quick-create-booking']);
  }

  getMassageLength() {


    if (this.newCurrentBooking.treatmentEnd && this.newCurrentBooking.treatmentStart) {

      const end = new Date(this.newCurrentBooking.treatmentEnd);
      const start = new Date(this.newCurrentBooking.treatmentStart);

      const diffMs = (end.getTime() - start.getTime());
      const timeInSecs = diffMs / 1000;
      const timeInMins = timeInSecs / 60;
      const timeInMinsRoundUp = Math.round(timeInMins);

      return timeInMinsRoundUp.toFixed(0);
    }
    else {
      return '999';
    }
  }

  logOutUser() {
    this.router.navigate(['login']);
    this.authService.logout().subscribe({});
  }

}


@Component({
  selector: 'decline-booking-dialog',
  templateUrl: 'booking-decline-dialog.html',
  standalone: true,
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],
})

export class DeclineBookingDialog {
  constructor(private dialogRef: MatDialogRef<DeclineBookingDialog>) {
  }
}


function toUtcDate(date: string | Date): Date {
  if (date instanceof Date) {
    const isoString = date.toISOString();
    return new Date(isoString);
  } else {
    return new Date(date.endsWith('Z') ? date : date + 'Z');
  }
}
